<template>
  <b-modal
    id="modal-workplace-activate"
    ref="workplaceActivateModal"
    title="Ativar Unidade"
    hide-footer
    size="xl"
    centered
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <div
      v-if="workplaceActivate.institution"
      class="mb-1 text-muted"
    >
      {{ workplaceActivate.institution }}
    </div>

    <form-wizard
      color="#575756"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Ativar"
      next-button-text="Próximo"
      back-button-text="Voltar"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- accoint details tab -->
      <tab-content
        title="Lançamento e Antecipação"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="-m-2"
            >
              <h5 class="mb-0">
                Início Lançamento
              </h5>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Tipo Plantão/Serviço"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Tipo Plantão/Serviço"
                  rules="required"
                >
                  <v-select
                    id="person-type"
                    v-model="formData.person_type"
                    name="person-type"
                    :options="requestTypeOptions"
                    label="label"
                    item-value="value"
                    item-text="label"
                    :clearable="false"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Data"
                label-for="request-enabled-at"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Data"
                  rules="required"
                >
                  <b-form-datepicker
                    id="request-enabled-at"
                    v-model="formData.request_enabled_at"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    locale="pt-BR"
                    label-help=""
                    label-no-date-selected="Selecione"
                    reset-button
                    label-reset-button="Limpar"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Tipo de Serviços"
                label-for="service-type-can-released"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Tipo de Serviços"
                  rules="required"
                >
                  <v-select
                    id="service-type-can-released"
                    v-model="formData.service_type_can_released"
                    name="service-type-can-released"
                    :options="serviceTypeCanReleasedOptions"
                    label="label"
                    item-value="value"
                    item-text="label"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Dia Limite Antecipação"
                label-for="advance-deadline-day"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Dia Limite Antecipação"
                  rules="required"
                >
                  <v-select
                    id="advance-deadline-day"
                    v-model="formData.advance_deadline_day"
                    name="advance-deadline-day"
                    :options="advanceDeadlineDayOptions"
                    :reduce="option => option.value"
                    label="label"
                    item-value="value"
                    item-text="label"
                    :clearable="false"
                    :searchable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              class="mt-2"
            >
              <h5 class="mb-0">
                Tipo Lançamento
              </h5>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Tipo"
                label-for="launch-mode"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Tipo"
                  rules="required"
                >
                  <v-select
                    id="launch-mode"
                    v-model="formData.physician_duty_launch_mode"
                    name="launch-mode"
                    :options="launchModeOptions"
                    label="label"
                    item-value="value"
                    item-text="label"
                    :clearable="false"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              class="mt-2"
            >
              <h5 class="mb-0">
                Habilitar Antecipação
              </h5>
            </b-col>
            <b-col md="3">
              <b-form-group class="mt-1">
                <div class="d-flex">
                  <div>
                    <p class="mr-1">
                      Habilitar?
                    </p>
                  </div>
                  <div>
                    <b-form-checkbox
                      v-model="formData.can_advance"
                      class="custom-control-secondary"
                      name="habilitar"
                      switch
                    >
                      <span class="switch-icon-left">
                        <feather-icon icon="CheckIcon" />
                      </span>
                      <span class="switch-icon-right">
                        <feather-icon icon="XIcon" />
                      </span>
                    </b-form-checkbox>
                  </div>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- personal details tab -->
      <tab-content
        title="Editar vencimento"
        :before-change="validationFormInfo"
      >
        <workplace-due-date-rules-form
          ref="dueDateRulesForm"
        />
      </tab-content>
    </form-wizard>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BFormDatepicker,
} from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { onUnmounted, ref } from '@vue/composition-api'
import vSelect from 'vue-select'

import WorkplaceDueDateRulesForm from '@/views/institution/institution-edit/workplace-list/workplace-due-date-rules/WorkplaceDueDateRulesForm.vue'
import useWorkplaceDueDateRulesSave from '@/views/institution/institution-edit/workplace-list/workplace-due-date-rules/useWorkplaceDueDateRulesSave'
import store from '@/store'
import reportStoreModule from '@/views/report/reportStoreModule'
import useWorkplaceActivate from './useWorkplaceActivate'

export default {
  components: {
    BFormDatepicker,
    BModal,
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    vSelect,
    WorkplaceDueDateRulesForm,
  },
  directives: {
    'b-modal': VBModal,
  },
  methods: {
    onModalShown() {
      const { workplace } = this.workplaceActivate
      if (workplace && this.$refs.dueDateRulesForm) {
        this.$refs.dueDateRulesForm.loadWorkplace(workplace)
      }
    },
    onModalHidden() {
      this.$emit('refetch-data')
    },
    async formSubmitted() {
      try {
        await this.saveDueDateRulesCallback(this.$refs.dueDateRulesForm, this.mockSaveDueDateRules)
        this.workplaceActivateModal.hide()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ativado',
            icon: 'EditIcon',
            variant: 'success',
          },
        })
      } catch {
        // mantém o modal aberto em caso de erro de validação ou salvamento
      }
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        if (this.$refs.dueDateRulesForm?.validate()) {
          resolve(true)
        } else {
          reject()
        }
      })
    },
  },
  setup(_, { emit }) {
    const STORE_MODULE_NAME = 'app-reports'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, reportStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const requestTypeOptions = [
      { label: 'PJ', value: 'PJ' },
      { label: 'PF', value: 'PF' },
    ]
    const serviceTypeCanReleasedOptions = [
      { label: 'Plantão', value: 'physician_duty' },
      { label: 'Serviços', value: 'service_record' },
      { label: 'Todos', value: 'all' },
    ]
    const launchModeOptions = [
      { label: 'IMEDIATO', value: 'imediato' },
      { label: 'Integração', value: 'integration' },
      { label: 'IMEDIATO/Integração', value: 'imediato_integration' },
    ]
    // eslint-disable-next-line no-shadow
    const days = Array.from({ length: 15 }, (_, i) => i + 1)
    const advanceDeadlineDayOptions = ref(days.map(day => ({ label: `${day}`, value: day })))

    const getInitialFormData = () => ({
      can_advance: false,
      service_type_can_released: null,
      person_type: null,
      advance_deadline_day: null,
      physician_duty_launch_mode: null,
      request_enabled_at: null,
    })

    const formData = ref(getInitialFormData())

    const {
      workplaceActivateModal,
      workplaceActivate,
      show: openWorkplaceActivateModal,
    } = useWorkplaceActivate()

    function show(workplace) {
      formData.value = getInitialFormData()
      openWorkplaceActivateModal(workplace)
    }

    const { saveDueDateRulesCallback } = useWorkplaceDueDateRulesSave(() => emit('refetch-data'))

    function mockSaveDueDateRules(payload) {
      const data = {
        workplace_id: payload.workplace_id,
        due_date_rules: payload.due_date_rules,
        service_type_can_released: formData.value.service_type_can_released.value,
        person_type: formData.value.person_type.value,
        can_advance: formData.value.can_advance,
        advance_deadline_day: formData.value.advance_deadline_day,
        physician_duty_launch_mode: formData.value.physician_duty_launch_mode.value,
        request_enabled_at: formData.value.request_enabled_at,
      }
      return store.dispatch(`${STORE_MODULE_NAME}/activate`, data)
    }

    return {
      launchModeOptions,
      advanceDeadlineDayOptions,
      serviceTypeCanReleasedOptions,
      requestTypeOptions,
      formData,
      workplaceActivateModal,
      workplaceActivate,
      show,
      saveDueDateRulesCallback,
      mockSaveDueDateRules,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
